/**
 * An exception which communicates that this Waiter timed out.
 * @param message
 * @constructor
 */
function WaiterTimeoutException(message) {
  this.name = 'WaiterTimeoutException';
  this.message = message;
  this.stack = (new Error()).stack;
}
WaiterTimeoutException.prototype = Object.create(Error.prototype);
WaiterTimeoutException.prototype.constructor = WaiterTimeoutException;

/**
 * An exception which communicates that this Waiter was cancelled.
 * @param message
 * @constructor
 */
function WaiterCancelException(message) {
  this.name = 'WaiterCancelException';
  this.message = message;
  this.stack = (new Error()).stack;
}
WaiterCancelException.prototype = Object.create(Error.prototype);
WaiterCancelException.prototype.constructor = WaiterCancelException;


const DEFAULT_TIMEOUT = 30 * 1000;
const DEFAULT_PERIODIC = 50;

class Waiter {
  /**
   * Construct a Waiter.
   * If a timeout value of 0 is specified, then no timeout will be applied. The default timeout is 30,000 milliseconds.
   *
   * @param selector
   * @param timeout - a timeout in milliseconds
   * @param document - supply an alternate (e.g. iframe) document element
   * @param periodic - specify an amount of time to periodically check for the element
   */
  constructor(selector, timeout = DEFAULT_TIMEOUT, document = window.document, periodic = DEFAULT_PERIODIC) {
    this.selector = selector;
    this.timeout = timeout;
    this.document = document;
    this.periodic = periodic;

    this.intervalId = null;
    this.promise = null;
    this.reject = null;
  }

  _resetInterval() {
    if (typeof this.intervalId === 'number') {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  cancel() {
    this._resetInterval();
    if (typeof this.reject === 'function') {
      this.promise = null;
      this.reject(new WaiterCancelException(`Cancelled waiting for elements matching "${this.selector}".`));
    }
  }

  wait() {
    if (!this.promise) {
      const expires = Date.now() + this.timeout;
      this.promise = new Promise((resolve, reject) => {
        this._resetInterval();
        this.intervalId = setInterval(() => {
          const elements = this.document.querySelectorAll(this.selector);
          if (elements.length > 0) {
            this._resetInterval();
            this.promise = null;
            resolve(elements);
          } else if (this.timeout !== 0 && Date.now() > expires) {
            this._resetInterval();
            this.promise = null;
            reject(new WaiterTimeoutException(`Unexpectedly did not find any elements matching "${this.selector}" after waiting ${this.timeout} ms.`));
          }
        }, this.periodic);
      });
    }
    return this.promise;
  }
}

module.exports = {Waiter, WaiterTimeoutException, WaiterCancelException};


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/waiter.js